
// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { useSelector } from 'react-redux';
// import { selectUser } from '../Commonlibs/userSlice';
// import {
//   Box,
//   Grid,
//   Typography,
//   Button,
//   Pagination,
//   Card,
//   CardContent,
//   IconButton,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   TextField,
//   InputAdornment,
//   Snackbar,
//   Alert,
// } from '@mui/material';
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import EditIcon from '@mui/icons-material/Edit';
// import ShareIcon from '@mui/icons-material/Share';
// import ContentCopyIcon from '@mui/icons-material/ContentCopy';
// import Loader from '../Loader/Loader';

// const outfitFontStyle = {
//   fontFamily: 'Outfit, sans-serif',
// };

// const PropertySeeAll = ({ onEditProperty }) => {
//   const navigate = useNavigate();
//   const [page, setPage] = useState(1);
//   const [loading, setLoading] = useState(true);
//   const [properties, setProperties] = useState([]);
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalProperties, setTotalProperties] = useState(0);
//   const user = useSelector(selectUser);

//   // Share dialog state
//   const [shareDialog, setShareDialog] = useState(false);
//   const [shareUrl, setShareUrl] = useState('');
//   const [selectedPropertyId, setSelectedPropertyId] = useState(null);

//   // Toast notification state
//   const [toast, setToast] = useState({
//     open: false,
//     message: '',
//     severity: 'success'
//   });

//   const itemsPerPage = 8;

//   useEffect(() => {
//     fetchProperties();
//   }, [user, page]);

//   const fetchProperties = async () => {
//     setLoading(true);
//     try {
//       const sellerId = user?.id || 2;
//       // ✅ FIXED: Removed status=approved filter to get ALL properties
//       const response = await fetch(
//         `https://propertydealstalk.com/api/seller/getPropertiesBySellerId?seller_id=${sellerId}&page=${page}&limit=${itemsPerPage}`
//       );
//       const data = await response.json();

//       if (data.status === "SUCCESS" && data.result) {
//         console.log('API Response:', data.result);
        
//         // Sort properties by latest first (createdAt or updatedAt)
//         const sortedProperties = (data.result.properties || []).sort((a, b) => {
//           const dateA = new Date(b.updatedAt || b.createdAt);
//           const dateB = new Date(a.updatedAt || a.createdAt);
//           return dateA - dateB;
//         });

//         // Process the properties to check for valid images
//         const processedProperties = sortedProperties.map(property => {
//           const hasImage = hasValidImage(property);
//           return {
//             ...property,
//             hasValidImage: hasImage,
//             processedImageUrl: hasImage ? getPropertyImage(property) : null
//           };
//         });

//         setProperties(processedProperties);
//         setTotalProperties(data.result.total || 0);
//         setTotalPages(data.result.totalPages || 1);
//       } else {
//         console.error('Failed to fetch properties:', data);
//         setProperties([]);
//       }
//     } catch (error) {
//       console.error('Error fetching properties:', error);
//       setProperties([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ✅ Function to check if property has a valid image
//   const hasValidImage = (property) => {
//     // Check image field
//     if (property.image && 
//         property.image.length > 100 && 
//         property.image !== "iVBORw0KGgoAAAANSUhEUgAAB4AAAAQ4CAYAAADo08FDAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAP+6SURBVHhe7N13fFRV/sbxz52aNqSHEmoSeleaKApYsGNby651rbv2Xde1rb3gWra46tpiXqHUNAAAAAASUVORK5CYII=") {
//       return true;
//     }

//     // Check primary_image field
//     if (property.primary_image && property.primary_image.length > 100) {
//       return true;
//     }

//     // Check images field
//     if (property.images) {
//       if (typeof property.images === 'string' && property.images.length > 100) {
//         return true;
//       }
//     }

//     return false;
//   };

//   // Function to get property image
//   const getPropertyImage = (property) => {
//     // Check for image field first
//     if (property.image && 
//         property.image.length > 100 && 
//         property.image !== "iVBORw0KGgoAAAANSUhEUgAAB4AAAAQ4CAYAAADo08FDAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAP+6SURBVHhe7N13fFRV/sbxz52aNqSHEmoSeleaKApYsGNby651rbv2Xde1rb3gWra46tpiXqHUNAAAAAASUVORK5CYII=") {
//       return `data:image/png;base64,${property.image}`;
//     }

//     // Then check for primary_image
//     if (property.primary_image && property.primary_image.length > 100) {
//       return `data:image/jpeg;base64,${property.primary_image}`;
//     }

//     // Then check for images field
//     if (property.images) {
//       // If it's a string and looks like base64
//       if (typeof property.images === 'string' && property.images.length > 100) {
//         // If it doesn't already have the data URL prefix
//         if (!property.images.startsWith('data:image')) {
//           return `data:image/jpeg;base64,${property.images}`;
//         } else {
//           return property.images;
//         }
//       }
//     }

//     return null;
//   };

//   const handleChangePage = (_, newPage) => setPage(newPage);

//   const formatCurrency = (amount, currency = '₹') => {
//     if (!amount) return null;
//     return `${currency}${Number(amount).toLocaleString()}`;
//   };

//   // ✅ UPDATED: Enhanced status display with more status types
//   const getStatusClass = (status) => {
//     switch(status?.toLowerCase()) {
//       case 'active':
//       case 'approved':
//         return '#10b981'; // Green
//       case 'under_verification':
//       case 'pending':
//         return '#f59e0b'; // Orange/Yellow
//       case 'rejected':
//       case 'declined':
//         return '#ef4444'; // Red
//       case 'inactive':
//       case 'expired':
//         return '#6b7280'; // Gray
//       default:
//         return 'rgba(0,0,0,0.7)';
//     }
//   };

//   // ✅ UPDATED: Enhanced status text display
//   const getStatusText = (status) => {
//     if (!status) return 'Unknown';
    
//     const statusMap = {
//       'active': 'Active',
//       'approved': 'Approved',
//       'under_verification': 'Under Verification',
//       'pending': 'Pending',
//       'rejected': 'Rejected',
//       'declined': 'Declined',
//       'inactive': 'Inactive',
//       'expired': 'Expired'
//     };
    
//     return statusMap[status.toLowerCase()] || status.charAt(0).toUpperCase() + status.slice(1);
//   };

//   // ✅ Function to handle View button click
//   const handleViewProperty = (propertyId) => {
//     navigate(`/view/${propertyId}`);
//   };

//   // ✅ Function to handle Share button click
//   const handleShareClick = (propertyId) => {
//     const publicUrl = `${window.location.origin}/view/${propertyId}?shared=true`;
//     setShareUrl(publicUrl);
//     setSelectedPropertyId(propertyId);
//     setShareDialog(true);
//   };

//   // ✅ Function to copy URL to clipboard
//   const handleCopyUrl = async () => {
//     try {
//       await navigator.clipboard.writeText(shareUrl);
//       setToast({
//         open: true,
//         message: 'Property link copied to clipboard!',
//         severity: 'success'
//       });
//     } catch (err) {
//       console.error('Failed to copy URL:', err);
//       setToast({
//         open: true,
//         message: 'Failed to copy link',
//         severity: 'error'
//       });
//     }
//   };

//   // ✅ Function to close share dialog
//   const handleCloseShareDialog = () => {
//     setShareDialog(false);
//     setSelectedPropertyId(null);
//   };

//   // Function to close toast notification
//   const handleCloseToast = (event, reason) => {
//     if (reason === 'clickaway') {
//       return;
//     }
//     setToast(prev => ({ ...prev, open: false }));
//   };

//   if (loading) return <Loader />;

//   return (
//     <Box
//       sx={{
//         mt: '0px',
//         mb: { xs: '100px', md: '140px' },
//         mx: 'auto',
//         px: { xs: 2, md: 2 },
//         width: '100%',
//         maxWidth: '1100px',
//         border: '2px solid #f1f1f1',
//         borderRadius: '16px',
//         background: '#fff',
//         boxSizing: 'border-box',
//         py: { xs: 4, md: 6 },
//       }}
//     >
//       <Box
//         sx={{
//           display: 'flex',
//           justifyContent: 'space-between',
//           alignItems: 'center',
//           mb: 4,
//           px: { xs: 1, md: 2 },
//         }}
//       >
//         <Typography
//           variant="h5"
//           sx={{ ...outfitFontStyle, fontWeight: 600, color: '#111827' }}
//         >
//           My Properties ({totalProperties})
//         </Typography>
//       </Box>

//       {/* Properties Grid */}
//       {properties.length === 0 ? (
//         <Box sx={{ textAlign: 'center', py: 8 }}>
//           <Typography variant="h6" color="#666" sx={outfitFontStyle}>
//             No properties found
//           </Typography>
//           <Typography variant="body2" color="#999" sx={{ mt: 1, ...outfitFontStyle }}>
//             Start by adding your first property
//           </Typography>
//         </Box>
//       ) : (
//         <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3, px: 1 }}>
//           {properties.map((property) => (
//             <Box
//               key={property.id}
//               sx={{
//                 width: { xs: '100%', sm: 'calc(50% - 12px)', md: 'calc(33.333% - 16px)' },
//                 mb: 1
//               }}
//             >
//               <Card
//                 sx={{
//                   borderRadius: '12px',
//                   overflow: 'hidden',
//                   boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
//                   height: '100%',
//                   display: 'flex',
//                   flexDirection: 'column',
//                   position: 'relative',
//                   transition: 'all 0.3s ease',
//                   '&:hover': {
//                     boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
//                     transform: 'translateY(-2px)',
//                   },
//                 }}
//               >
//                 {/* ✅ Status Badge - Now shows all statuses */}
//                 {property.status && (
//                   <Box
//                     sx={{
//                       position: 'absolute',
//                       top: 10,
//                       right: 10,
//                       backgroundColor: getStatusClass(property.status),
//                       color: 'white',
//                       padding: '4px 10px',
//                       borderRadius: '4px',
//                       fontSize: '10px',
//                       fontWeight: 500,
//                       zIndex: 1,
//                       ...outfitFontStyle,
//                     }}
//                   >
//                     {getStatusText(property.status)}
//                   </Box>
//                 )}

//                 {/* Property Image */}
//                 {property.hasValidImage ? (
//                   <Box
//                     component="img"
//                     src={property.processedImageUrl}
//                     alt={property.property_name || "Property"}
//                     sx={{
//                       width: '100%',
//                       height: '180px',
//                       objectFit: 'cover',
//                       backgroundColor: '#f5f5f5'
//                     }}
//                   />
//                 ) : (
//                   <Box
//                     sx={{
//                       width: '100%',
//                       height: '180px',
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                       backgroundColor: '#f5f5f5',
//                       border: '1px dashed #ccc'
//                     }}
//                   >
//                     <Typography variant="body2" color="#888" textAlign="center" px={2}>
//                       No images uploaded
//                     </Typography>
//                   </Box>
//                 )}

//                 <CardContent
//                   sx={{
//                     p: 2,
//                     flexGrow: 1,
//                     display: 'flex',
//                     flexDirection: 'column',
//                     justifyContent: 'space-between',
//                   }}
//                 >
//                   <Box>
//                     <Box
//                       sx={{
//                         display: 'flex',
//                         justifyContent: 'space-between',
//                         alignItems: 'flex-start',
//                         mb: 1,
//                         gap: 1,
//                       }}
//                     >
//                       <Typography
//                         variant="h6"
//                         sx={{
//                           ...outfitFontStyle,
//                           fontWeight: 600,
//                           fontSize: '16px',
//                           mb: 0.5,
//                           flex: 1,
//                           lineHeight: 1.3,
//                         }}
//                       >
//                         {property.property_name || "Unnamed Property"}
//                       </Typography>
//                       <Button
//                         size="small"
//                         startIcon={<EditIcon sx={{ fontSize: 14 }} />}
//                         onClick={() => navigate(`/sell-properties/edit/${property.id}`)}
//                         sx={{
//                           minWidth: 'auto',
//                           px: 1,
//                           py: 0.5,
//                           color: '#3b82f6',
//                           fontSize: '12px',
//                           textTransform: 'none',
//                           '&:hover': {
//                             backgroundColor: 'rgba(59, 130, 246, 0.08)',
//                           },
//                           ...outfitFontStyle,
//                         }}
//                       >
//                         Edit
//                       </Button>
//                     </Box>

//                     <Typography
//                       variant="h6"
//                       sx={{
//                         ...outfitFontStyle,
//                         fontWeight: 700,
//                         color: '#3b82f6',
//                         mb: 1,
//                         fontSize: '18px',
//                       }}
//                     >
//                       {property.category === 'sale'
//                         ? formatCurrency(property.asking_price, property.currency)
//                         : `${formatCurrency(property.monthly_rent, property.currency)}/month`}
//                     </Typography>

//                     <Typography
//                       variant="body2"
//                       sx={{
//                         ...outfitFontStyle,
//                         color: '#6b7280',
//                         fontSize: '14px',
//                         mb: 2,
//                         lineHeight: 1.4,
//                       }}
//                     >
//                       {property.area_name || ""}, {property.location || ""}
//                     </Typography>
//                   </Box>

//                   {/* View and Share Buttons */}
//                   <Box
//                     sx={{
//                       display: 'flex',
//                       gap: 1,
//                       mb: 2,
//                     }}
//                   >
//                     <Button
//                       fullWidth
//                       variant="contained"
//                       startIcon={<VisibilityIcon />}
//                       onClick={() => handleViewProperty(property.id)}
//                       sx={{
//                         ...outfitFontStyle,
//                         textTransform: 'none',
//                         fontSize: '13px',
//                         fontWeight: 500,
//                         py: 0.75,
//                         backgroundColor: '#3b82f6',
//                         '&:hover': {
//                           backgroundColor: '#2563eb',
//                         },
//                       }}
//                     >
//                       View
//                     </Button>
//                     <Button
//                       fullWidth
//                       variant="outlined"
//                       startIcon={<ShareIcon />}
//                       onClick={() => handleShareClick(property.id)}
//                       sx={{
//                         ...outfitFontStyle,
//                         textTransform: 'none',
//                         fontSize: '13px',
//                         fontWeight: 500,
//                         py: 0.75,
//                         borderColor: '#3b82f6',
//                         color: '#3b82f6',
//                         '&:hover': {
//                           borderColor: '#2563eb',
//                           backgroundColor: 'rgba(59, 130, 246, 0.04)',
//                         },
//                       }}
//                     >
//                       Share
//                     </Button>
//                   </Box>

//                   <Box
//                     sx={{
//                       display: 'flex',
//                       justifyContent: 'space-between',
//                       alignItems: 'center',
//                       pt: 1,
//                       borderTop: '1px solid #f3f4f6',
//                     }}
//                   >
//                     <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                       <VisibilityIcon
//                         sx={{ fontSize: 16, color: '#9ca3af', mr: 0.5 }}
//                       />
//                       <Typography
//                         variant="caption"
//                         sx={{
//                           ...outfitFontStyle,
//                           color: '#6b7280',
//                           fontSize: '12px',
//                           fontWeight: 500,
//                         }}
//                       >
//                         0 Views
//                       </Typography>
//                     </Box>
//                     <Typography
//                       variant="caption"
//                       sx={{
//                         ...outfitFontStyle,
//                         color: '#9ca3af',
//                         fontSize: '11px',
//                       }}
//                     >
//                       Property ID: #PD{property.id.toString().padStart(6, '0')}
//                     </Typography>
//                   </Box>
//                 </CardContent>
//               </Card>
//             </Box>
//           ))}
//         </Box>
//       )}

//       {/* Pagination */}
//       {totalPages > 1 && (
//         <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 6, pr: { xs: 2, md: 4 } }}>
//           <Pagination
//             count={totalPages}
//             page={page}
//             onChange={handleChangePage}
//             color="primary"
//             size="large"
//             sx={{
//               '& .MuiPaginationItem-root': {
//                 ...outfitFontStyle,
//                 fontWeight: 500,
//               },
//             }}
//           />
//         </Box>
//       )}

//       {/* Share Dialog */}
//       <Dialog
//         open={shareDialog}
//         onClose={handleCloseShareDialog}
//         maxWidth="sm"
//         fullWidth
//       >
//         <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//           <Typography variant="h6" fontWeight={600} sx={outfitFontStyle}>
//             Share Property
//           </Typography>
//           <IconButton onClick={handleCloseShareDialog} size="small">
//             <ContentCopyIcon />
//           </IconButton>
//         </DialogTitle>
//         <DialogContent>
//           <Typography variant="body2" color="#666" mb={2} sx={outfitFontStyle}>
//             Share this property link with potential buyers. The link will show property details without seller contact information.
//           </Typography>
//           <TextField
//             fullWidth
//             value={shareUrl}
//             InputProps={{
//               readOnly: true,
//               endAdornment: (
//                 <InputAdornment position="end">
//                   <IconButton
//                     onClick={handleCopyUrl}
//                     edge="end"
//                     color="primary"
//                     title="Copy URL"
//                   >
//                     <ContentCopyIcon />
//                   </IconButton>
//                 </InputAdornment>
//               ),
//             }}
//             variant="outlined"
//             sx={{
//               '& .MuiOutlinedInput-root': {
//                 backgroundColor: '#f5f5f5',
//                 ...outfitFontStyle,
//               }
//             }}
//           />
//         </DialogContent>
//         <DialogActions sx={{ px: 3, pb: 2 }}>
//           <Button onClick={handleCloseShareDialog} variant="outlined" sx={outfitFontStyle}>
//             Close
//           </Button>
//           <Button 
//             onClick={handleCopyUrl} 
//             variant="contained" 
//             startIcon={<ContentCopyIcon />}
//             sx={outfitFontStyle}
//           >
//             Copy Link
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Toast Notification */}
//       <Snackbar
//         open={toast.open}
//         autoHideDuration={4000}
//         onClose={handleCloseToast}
//         anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//       >
//         <Alert 
//           onClose={handleCloseToast} 
//           severity={toast.severity} 
//           sx={{ width: '100%', ...outfitFontStyle }}
//         >
//           {toast.message}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// };

// export default PropertySeeAll;



import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectUser } from '../Commonlibs/userSlice';
import {
  Box,
  Grid,
  Typography,
  Button,
  Pagination,
  Card,
  CardContent,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  InputAdornment,
  Snackbar,
  Alert,
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import ShareIcon from '@mui/icons-material/Share';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Loader from '../Loader/Loader';

const outfitFontStyle = {
  fontFamily: 'Outfit, sans-serif',
};

const PropertySeeAll = ({ onEditProperty }) => {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [properties, setProperties] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [totalProperties, setTotalProperties] = useState(0);
  const user = useSelector(selectUser);

  // Share dialog state
  const [shareDialog, setShareDialog] = useState(false);//updated false 
  const [shareUrl, setShareUrl] = useState('');
  const [selectedPropertyId, setSelectedPropertyId] = useState(null);

  // Toast notification state
  const [toast, setToast] = useState({
    open: false,
    message: '',
    severity: 'success'
  });

  const itemsPerPage = 8;

  useEffect(() => {
    fetchProperties();
  }, [user, page]);

  const fetchProperties = async () => {
    setLoading(true);
    try {
      const sellerId = user?.id || 2;
      // ✅ FIXED: Removed status=approved filter to get ALL properties
      const response = await fetch(
        `https://propertydealstalk.com/api/seller/getPropertiesBySellerId?seller_id=${sellerId}&page=${page}&limit=${itemsPerPage}`
      );
      const data = await response.json();

      if (data.status === "SUCCESS" && data.result) {
        console.log('API Response:', data.result);
        
        // Sort properties by latest first (createdAt or updatedAt)
        const sortedProperties = (data.result.properties || []).sort((a, b) => {
          const dateA = new Date(b.updatedAt || b.createdAt);
          const dateB = new Date(a.updatedAt || a.createdAt);
          return dateA - dateB;
        });

        // Process the properties to check for valid images
        const processedProperties = sortedProperties.map(property => {
          const hasImage = hasValidImage(property);
          return {
            ...property,
            hasValidImage: hasImage,
            processedImageUrl: hasImage ? getPropertyImage(property) : null
          };
        });

        setProperties(processedProperties);
        setTotalProperties(data.result.total || 0);
        setTotalPages(data.result.totalPages || 1);
      } else {
        console.error('Failed to fetch properties:', data);
        setProperties([]);
      }
    } catch (error) {
      console.error('Error fetching properties:', error);
      setProperties([]);
    } finally {
      setLoading(false);
    }
  };

  // ✅ Function to check if property has a valid image
  const hasValidImage = (property) => {
    // Check image field
    if (property.image && 
        property.image.length > 100 && 
        property.image !== "iVBORw0KGgoAAAANSUhEUgAAB4AAAAQ4CAYAAADo08FDAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAP+6SURBVHhe7N13fFRV/sbxz52aNqSHEmoSeleaKApYsGNby651rbv2Xde1rb3gWra46tpiXqHUNAAAAAASUVORK5CYII=") {
      return true;
    }

    // Check primary_image field
    if (property.primary_image && property.primary_image.length > 100) {
      return true;
    }

    // Check images field
    if (property.images) {
      if (typeof property.images === 'string' && property.images.length > 100) {
        return true;
      }
    }

    return false;
  };

  // Function to get property image
  const getPropertyImage = (property) => {
    // Check for image field first
    if (property.image && 
        property.image.length > 100 && 
        property.image !== "iVBORw0KGgoAAAANSUhEUgAAB4AAAAQ4CAYAAADo08FDAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAP+6SURBVHhe7N13fFRV/sbxz52aNqSHEmoSeleaKApYsGNby651rbv2Xde1rb3gWra46tpiXqHUNAAAAAASUVORK5CYII=") {
      return `data:image/png;base64,${property.image}`;
    }

    // Then check for primary_image
    if (property.primary_image && property.primary_image.length > 100) {
      return `data:image/jpeg;base64,${property.primary_image}`;
    }

    // Then check for images field
    if (property.images) {
      // If it's a string and looks like base64
      if (typeof property.images === 'string' && property.images.length > 100) {
        // If it doesn't already have the data URL prefix
        if (!property.images.startsWith('data:image')) {
          return `data:image/jpeg;base64,${property.images}`;
        } else {
          return property.images;
        }
      }
    }

    return null;
  };

  const handleChangePage = (_, newPage) => setPage(newPage);

  const formatCurrency = (amount, currency = '₹') => {
    if (!amount) return null;
    return `${currency}${Number(amount).toLocaleString()}`;
  };

  // ✅ NEW: Function to format time ago (like "2w ago")
  const getTimeAgo = (dateString) => {
    if (!dateString) return '';
    
    const date = new Date(dateString);
    const now = new Date();
    const diffInSeconds = Math.floor((now - date) / 1000);
    
    const intervals = {
      y: 31536000,
      mo: 2592000,
      w: 604800,
      d: 86400,
      h: 3600,
      m: 60,
      s: 1
    };
    
    for (const [key, value] of Object.entries(intervals)) {
      const interval = Math.floor(diffInSeconds / value);
      if (interval >= 1) {
        return `${interval}${key} ago`;
      }
    }
    
    return 'just now';
  };

  // ✅ UPDATED: Enhanced status display with more status types
  const getStatusClass = (status) => {
    switch(status?.toLowerCase()) {
      case 'active':
      case 'approved':
        return '#10b981'; // Green
      case 'under_verification':
      case 'pending':
        return '#f59e0b'; // Orange/Yellow
      case 'rejected':
      case 'declined':
        return '#ef4444'; // Red
      case 'inactive':
      case 'expired':
        return '#6b7280'; // Gray
      default:
        return 'rgba(0,0,0,0.7)';
    }
  };

  // ✅ UPDATED: Enhanced status text display
  const getStatusText = (status) => {
    if (!status) return 'Unknown';
    
    const statusMap = {
      'active': 'Active',
      'approved': 'Approved',
      'under_verification': 'Under Verification',
      'pending': 'Pending',
      'rejected': 'Rejected',
      'declined': 'Declined',
      'inactive': 'Inactive',
      'expired': 'Expired'
    };
    
    return statusMap[status.toLowerCase()] || status.charAt(0).toUpperCase() + status.slice(1);
  };

  // ✅ Function to handle View button click
  const handleViewProperty = (propertyId) => {
    navigate(`/view/${propertyId}`);
  };

  // ✅ Function to handle Share button click
  const handleShareClick = (propertyId) => {
    const publicUrl = `${window.location.origin}/view/${propertyId}?shared=true`;
    setShareUrl(publicUrl);
    setSelectedPropertyId(propertyId);
    setShareDialog(true);
  };

  // ✅ Function to copy URL to clipboard
  const handleCopyUrl = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setToast({
        open: true,
        message: 'Property link copied to clipboard!',
        severity: 'success'
      });
    } catch (err) {
      console.error('Failed to copy URL:', err);
      setToast({
        open: true,
        message: 'Failed to copy link',
        severity: 'error'
      });
    }
  };

  // ✅ Function to close share dialog
  const handleCloseShareDialog = () => {
    setShareDialog(false);
    setSelectedPropertyId(null);
  };

  // Function to close toast notification
  const handleCloseToast = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setToast(prev => ({ ...prev, open: false }));
  };

  if (loading) return <Loader />;

  return (
    <Box
      sx={{
        mt: '0px',
        mb: { xs: '100px', md: '140px' },
        mx: 'auto',
        px: { xs: 2, md: 2 },
        width: '100%',
        maxWidth: '1100px',
        border: '2px solid #f1f1f1',
        borderRadius: '16px',
        background: '#fff',
        boxSizing: 'border-box',
        py: { xs: 4, md: 6 },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 4,
          px: { xs: 1, md: 2 },
        }}
      >
        <Typography
          variant="h5"
          sx={{ ...outfitFontStyle, fontWeight: 600, color: '#111827' }}
        >
          My Properties ({totalProperties})
        </Typography>
      </Box>

      {/* Properties Grid */}
      {properties.length === 0 ? (
        <Box sx={{ textAlign: 'center', py: 8 }}>
          <Typography variant="h6" color="#666" sx={outfitFontStyle}>
            No properties found
          </Typography>
          <Typography variant="body2" color="#999" sx={{ mt: 1, ...outfitFontStyle }}>
            Start by adding your first property
          </Typography>
        </Box>
      ) : (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3, px: 1 }}>
          {properties.map((property) => {
            const timeAgo = getTimeAgo(property.updatedAt || property.createdAt);
            
            return (
              <Box
                key={property.id}
                sx={{
                  width: { xs: '100%', sm: 'calc(50% - 12px)', md: 'calc(33.333% - 16px)' },
                  mb: 1
                }}
              >
                <Card
                  sx={{
                    borderRadius: '12px',
                    overflow: 'hidden',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    position: 'relative',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
                      transform: 'translateY(-2px)',
                    },
                  }}
                >
                  {/* ✅ Status Badge - Now shows all statuses */}
                  {property.status && (
                    <Box
                      sx={{
                        position: 'absolute',
                        top: 10,
                        right: 10,
                        backgroundColor: getStatusClass(property.status),
                        color: 'white',
                        padding: '4px 10px',
                        borderRadius: '4px',
                        fontSize: '10px',
                        fontWeight: 500,
                        zIndex: 2,
                        ...outfitFontStyle,
                      }}
                    >
                      {getStatusText(property.status)}
                    </Box>
                  )}

                  {/* ✅ Image Container with Time Badge */}
                  <Box sx={{ position: 'relative', width: '100%', height: '180px' }}>
                    {property.hasValidImage ? (
                      <Box
                        component="img"
                        src={property.processedImageUrl}
                        alt={property.property_name || "Property"}
                        sx={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                          backgroundColor: '#f5f5f5'
                        }}
                      />
                    ) : (
                      <Box
                        sx={{
                          width: '100%',
                          height: '100%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backgroundColor: '#f5f5f5',
                          border: '1px dashed #ccc'
                        }}
                      >
                        <Typography variant="body2" color="#888" textAlign="center" px={2}>
                          No images uploaded
                        </Typography>
                      </Box>
                    )}

                    {/* ✅ Time Ago Badge - Positioned at bottom-left */}
                    {timeAgo && (
                      <Box
                        sx={{
                          position: 'absolute',
                          bottom: '8px',
                          left: '8px',
                          bgcolor: 'rgba(0, 0, 0, 0.7)',
                          color: '#fff',
                          px: '8px',
                          py: '4px',
                          borderRadius: '4px',
                          fontSize: '11px',
                          fontWeight: 500,
                          zIndex: 1,
                          ...outfitFontStyle,
                        }}
                      >
                        {timeAgo}
                      </Box>
                    )}
                  </Box>

                  <CardContent
                    sx={{
                      p: 2,
                      flexGrow: 1,
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                    }}
                  >
                    <Box>
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'flex-start',
                          mb: 1,
                          gap: 1,
                        }}
                      >
                        <Typography
                          variant="h6"
                          sx={{
                            ...outfitFontStyle,
                            fontWeight: 600,
                            fontSize: '16px',
                            mb: 0.5,
                            flex: 1,
                            lineHeight: 1.3,
                          }}
                        >
                          {property.property_name || "Unnamed Property"}
                        </Typography>
                        <Button
                          size="small"
                          startIcon={<EditIcon sx={{ fontSize: 14 }} />}
                          onClick={() => navigate(`/sell-properties/edit/${property.id}`)}
                          sx={{
                            minWidth: 'auto',
                            px: 1,
                            py: 0.5,
                            color: '#3b82f6',
                            fontSize: '12px',
                            textTransform: 'none',
                            '&:hover': {
                              backgroundColor: 'rgba(59, 130, 246, 0.08)',
                            },
                            ...outfitFontStyle,
                          }}
                        >
                          Edit
                        </Button>
                      </Box>

                      <Typography
                        variant="h6"
                        sx={{
                          ...outfitFontStyle,
                          fontWeight: 700,
                          color: '#3b82f6',
                          mb: 1,
                          fontSize: '18px',
                        }}
                      >
                        {property.category === 'sale'
                          ? formatCurrency(property.asking_price, property.currency)
                          : `${formatCurrency(property.monthly_rent, property.currency)}/month`}
                      </Typography>

                      <Typography
                        variant="body2"
                        sx={{
                          ...outfitFontStyle,
                          color: '#6b7280',
                          fontSize: '14px',
                          mb: 2,
                          lineHeight: 1.4,
                        }}
                      >
                        {property.area_name || ""}, {property.location || ""}
                      </Typography>
                    </Box>

                    {/* View and Share Buttons */}
                    <Box
                      sx={{
                        display: 'flex',
                        gap: 1,
                        mb: 2,
                      }}
                    >
                      <Button
                        fullWidth
                        variant="contained"
                        startIcon={<VisibilityIcon />}
                        onClick={() => handleViewProperty(property.id)}
                        sx={{
                          ...outfitFontStyle,
                          textTransform: 'none',
                          fontSize: '13px',
                          fontWeight: 500,
                          py: 0.75,
                          backgroundColor: '#3b82f6',
                          '&:hover': {
                            backgroundColor: '#2563eb',
                          },
                        }}
                      >
                        View
                      </Button>
                      <Button
                        fullWidth
                        variant="outlined"
                        startIcon={<ShareIcon />}
                        onClick={() => handleShareClick(property.id)}
                        sx={{
                          ...outfitFontStyle,
                          textTransform: 'none',
                          fontSize: '13px',
                          fontWeight: 500,
                          py: 0.75,
                          borderColor: '#3b82f6',
                          color: '#3b82f6',
                          '&:hover': {
                            borderColor: '#2563eb',
                            backgroundColor: 'rgba(59, 130, 246, 0.04)',
                          },
                        }}
                      >
                        Share
                      </Button>
                    </Box>

                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        pt: 1,
                        borderTop: '1px solid #f3f4f6',
                      }}
                    >
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <VisibilityIcon
                          sx={{ fontSize: 16, color: '#9ca3af', mr: 0.5 }}
                        />
                        <Typography
                          variant="caption"
                          sx={{
                            ...outfitFontStyle,
                            color: '#6b7280',
                            fontSize: '12px',
                            fontWeight: 500,
                          }}
                        >
                          0 Views
                        </Typography>
                      </Box>
                      <Typography
                        variant="caption"
                        sx={{
                          ...outfitFontStyle,
                          color: '#9ca3af',
                          fontSize: '11px',
                        }}
                      >
                        Property ID: #PD{property.id.toString().padStart(6, '0')}
                      </Typography>
                    </Box>
                  </CardContent>
                </Card>
              </Box>
            );
          })}
        </Box>
      )}

      {/* Pagination */}
      {totalPages > 1 && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 6, pr: { xs: 2, md: 4 } }}>
          <Pagination
            count={totalPages}
            page={page}
            onChange={handleChangePage}
            color="primary"
            size="large"
            sx={{
              '& .MuiPaginationItem-root': {
                ...outfitFontStyle,
                fontWeight: 500,
              },
            }}
          />
        </Box>
      )}

      {/* Share Dialog */}
      <Dialog
        open={shareDialog}
        onClose={handleCloseShareDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h6" fontWeight={600} sx={outfitFontStyle}>
            Share Property
          </Typography>
          <IconButton onClick={handleCloseShareDialog} size="small">
            <ContentCopyIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="#666" mb={2} sx={outfitFontStyle}>
            Share this property link with potential buyers. The link will show property details without seller contact information.
          </Typography>
          <TextField
            fullWidth
            value={shareUrl}
            InputProps={{
              readOnly: true,
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={handleCopyUrl}
                    edge="end"
                    color="primary"
                    title="Copy URL"
                  >
                    <ContentCopyIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            variant="outlined"
            sx={{
              '& .MuiOutlinedInput-root': {
                backgroundColor: '#f5f5f5',
                ...outfitFontStyle,
              }
            }}
          />
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={handleCloseShareDialog} variant="outlined" sx={outfitFontStyle}>
            Close
          </Button>
          <Button 
            onClick={handleCopyUrl} 
            variant="contained" 
            startIcon={<ContentCopyIcon />}
            sx={outfitFontStyle}
          >
            Copy Link
          </Button>
        </DialogActions>
      </Dialog>

      {/* Toast Notification */}
      <Snackbar
        open={toast.open}
        autoHideDuration={4000}
        onClose={handleCloseToast}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert 
          onClose={handleCloseToast} 
          severity={toast.severity} 
          sx={{ width: '100%', ...outfitFontStyle }}
        >
          {toast.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default PropertySeeAll;